import { DataBean } from "../DataBean";

export class PlanAnualdeCuentas extends DataBean {


    public async getAdquisitionItemPACCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getAdquisitionItemPACCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }

}